import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as store from '../state';
import * as actions from './categories.actions'
import {
    createCategoriesLoading,
    createCategoriesData,
    createCategoriesFailData,
    getCategoriesListLoading,
    getCategoriesListData,
    getCategoriesListFailData,
    getCategoriesItemLoading,
    getCategoriesItemData,
    getCategoriesItemFailData,
    updateCategoriesItemLoading,
    updateCategoriesItemData,
    updateCategoriesItemFailData,
    deleteCategoriesItemLoading,
    deleteCategoriesItemFailData,
    deleteCategoriesItemData,
    createSliderItemLoading,
    createSliderItemData,
    createSliderItemFailData,
    getSliderItemLoading,
    getSliderItemData,
    getSliderItemFailData,
    getSliderListLoading,
    getSliderListData,
    getSliderListFailData,
    removeSliderItemLoading,
    removeSliderItemData,
    removeSliderItemFailData,
    updateSliderItemLoading,
    updateSliderItemData,
    updateSliderItemFailData,
    createPdfItemLoading,
    createPdfItemData,
    createPdfItemFailData,
    deletePdfItemLoading,
    deletePdfItemData,
    deletePdfItemFailData,
    updatePdfItemLoading,
    updatePdfItemData,
    updatePdfItemFailData,
    getPdfItemLoading,
    getPdfItemFailData,
    getPdfItemData,
    getPdfListLoading,
    getPdfListFailData,
    getPdfListData,
    getPdfListCount,
    createSliderLoading,
    createSliderData,
    createSliderFailData,
    updateSliderLoading,
    updateSliderData,
    updateSliderFailData,
    removeSliderLoading,
    removeSliderData,
    removeSliderFailData,
    getSliderLoading,
    getSliderData,
    getSliderFailData,
    getSlidersLoading,
    getSlidersData,
    getSlidersFailData
} from './categories.selector';

@Injectable()
export class CategoriesSandbox {
    public createCategoriesLoading$ = this.appState$.select(createCategoriesLoading);
    public createCategoriesData$ = this.appState$.select(createCategoriesData);
    public createCategoriesFailData$ = this.appState$.select(createCategoriesFailData);

    public getCategoriesListLoading$ = this.appState$.select(getCategoriesListLoading);
    public getCategoriesListData$ = this.appState$.select(getCategoriesListData);
    public getCategoriesListFailData$ = this.appState$.select(getCategoriesListFailData);

    public getCategoriesItemLoading$ = this.appState$.select(getCategoriesItemLoading);
    public getCategoriesItemData$ = this.appState$.select(getCategoriesItemData);
    public getCategoriesItemFailData$ = this.appState$.select(getCategoriesItemFailData);

    public updateCategoriesItemLoading$ = this.appState$.select(updateCategoriesItemLoading);
    public updateCategoriesItemData$ = this.appState$.select(updateCategoriesItemData);
    public updateCategoriesItemFailData$ = this.appState$.select(updateCategoriesItemFailData);

    public deleteCategoriesItemLoading$ = this.appState$.select(deleteCategoriesItemLoading);
    public deleteCategoriesItemData$ = this.appState$.select(deleteCategoriesItemData);
    public deleteCategoriesItemFailData$ = this.appState$.select(deleteCategoriesItemFailData);

    public createSliderItemLoading$ = this.appState$.select(createSliderItemLoading);
    public createSliderItemData$ = this.appState$.select(createSliderItemData);
    public createSliderItemFailData$ = this.appState$.select(createSliderItemFailData);

    public getSliderItemLoading$ = this.appState$.select(getSliderItemLoading);
    public getSliderItemData$ = this.appState$.select(getSliderItemData);
    public getSliderItemFailData$ = this.appState$.select(getSliderItemFailData);

    public getSliderListLoading$ = this.appState$.select(getSliderListLoading);
    public getSliderListData$ = this.appState$.select(getSliderListData);
    public getSliderListFailData$ = this.appState$.select(getSliderListFailData);
    public getPdfListCount$ = this.appState$.select(getPdfListCount);

    public removeSliderItemLoading$ = this.appState$.select(removeSliderItemLoading);
    public removeSliderItemData$ = this.appState$.select(removeSliderItemData);
    public removeSliderItemFailData$ = this.appState$.select(removeSliderItemFailData);

    public updateSliderItemLoading$ = this.appState$.select(updateSliderItemLoading);
    public updateSliderItemData$ = this.appState$.select(updateSliderItemData);
    public updateSliderItemFailData$ = this.appState$.select(updateSliderItemFailData);

    public createPdfItemLoading$ = this.appState$.select(createPdfItemLoading);
    public createPdfItemData$ = this.appState$.select(createPdfItemData);
    public createPdfItemFailData$ = this.appState$.select(createPdfItemFailData);

    public deletePdfItemLoading$ = this.appState$.select(deletePdfItemLoading);
    public deletePdfItemData$ = this.appState$.select(deletePdfItemData);
    public deletePdfItemFailData$ = this.appState$.select(deletePdfItemFailData);

    public updatePdfItemLoading$ = this.appState$.select(updatePdfItemLoading);
    public updatePdfItemData$ = this.appState$.select(updatePdfItemData);
    public updatePdfItemFailData$ = this.appState$.select(updatePdfItemFailData);

    public getPdfItemLoading$ = this.appState$.select(getPdfItemLoading);
    public getPdfItemData$ = this.appState$.select(getPdfItemData);
    public getPdfItemFailData$ = this.appState$.select(getPdfItemFailData);

    public getPdfListLoading$ = this.appState$.select(getPdfListLoading);
    public getPdfListData$ = this.appState$.select(getPdfListData);
    public getPdfListFailData$ = this.appState$.select(getPdfListFailData);

    public createSliderLoading$ = this.appState$.select(createSliderLoading);
    public createSliderData$ = this.appState$.select(createSliderData);
    public createSliderFailData$ = this.appState$.select(createSliderFailData);

    public updateSliderLoading$ = this.appState$.select(updateSliderLoading);
    public updateSliderData$ = this.appState$.select(updateSliderData);
    public updateSliderFailData$ = this.appState$.select(updateSliderFailData);

    public removeSliderLoading$ = this.appState$.select(removeSliderLoading);
    public removeSliderData$ = this.appState$.select(removeSliderData);
    public removeSliderFailData$ = this.appState$.select(removeSliderFailData);

    public getSliderLoading$ = this.appState$.select(getSliderLoading);
    public getSliderData$ = this.appState$.select(getSliderData);
    public getSliderFailData$ = this.appState$.select(getSliderFailData);

    public getSlidersLoading$ = this.appState$.select(getSlidersLoading);
    public getSlidersData$ = this.appState$.select(getSlidersData);
    public getSlidersFailData$ = this.appState$.select(getSlidersFailData);


    constructor(protected appState$: Store<store.AppState>) { }

    doCreateCategory(params: any): void {
        this.appState$.dispatch(new actions.CreateCategoryAction(params));
    }
    doClearCreateCategoryState(): void {
        this.appState$.dispatch(new actions.ClearCreateCategoryStateAction({}));
    }

    doGetCategoriesList(params: any): void {
        this.appState$.dispatch(new actions.GetCategoriesListAction(params));
    }

    doGetCategoriesItem(id: number): void {
        this.appState$.dispatch(new actions.GetCategoriesItemAction({ id: id }))
    }
    doClearGetCategoriesItemState(): void {
        this.appState$.dispatch(new actions.ClearGetCategoriesItemStateAction({}))
    }

    doUpdateCategoriesItem(id: number, params: any): void {
        this.appState$.dispatch(new actions.UpdateCategoriesItemAction({ id: id, params: params }))
    }
    doClearUpdateGetCategoriesItemState(): void {
        this.appState$.dispatch(new actions.ClearUpdateCategoriesItemStateAction({}))
    }

    doRemoveCategoriesItem(id: number): void {
        this.appState$.dispatch(new actions.RemoveCategoriesItemAction({ id: id }))
    }
    doClearRemoveGetCategoriesItemState(): void {
        this.appState$.dispatch(new actions.ClearRemoveCategoriesItemStateAction({}))
    }

    // 

    doCreateSliderItem(params: any): void {
        this.appState$.dispatch(new actions.CreateSliderItemAction(params));
    }
    doClearCreateSliderItemState(): void {
        this.appState$.dispatch(new actions.ClearCreateSliderItemAStatection({}));
    }

    doGetSliderItem(id: number): void {
        this.appState$.dispatch(new actions.GetSliderItemAction({ id: id }));
    }
    doClearGetSliderItemState(): void {
        this.appState$.dispatch(new actions.ClearGetSliderItemStateAction({}));
    }

    doGetSliderList(params: any): void {
        this.appState$.dispatch(new actions.GetSliderListAction(params));
    }
    doCLearGetSliderListState(): void {
        this.appState$.dispatch(new actions.ClearGetSliderListStateAction({}));
    }

    doRemoveSliderItem(id: number): void {
        this.appState$.dispatch(new actions.RemoveSliderItemAction({ id: id }));
    }
    doClearRemoveSliderItemState(): void {
        this.appState$.dispatch(new actions.ClearRemoveSliderItemStateAction({}));
    }

    doUpdateSliderItem(params: any): void {
        this.appState$.dispatch(new actions.UpdateSliderItemAction(params));
    }
    doClearUpdateSliderItemState(): void {
        this.appState$.dispatch(new actions.ClearUpdateSliderItemStateAction({}));
    }


    // 
    doCreatePdfItem(params: any): void {
        this.appState$.dispatch(new actions.CreatePdfItemAction(params));
    }
    doClearCreatePdfItemState(): void {
        this.appState$.dispatch(new actions.ClearCreatePdfItemStateAction({}));
    }

    doGetPdfItem(id: number): void {
        this.appState$.dispatch(new actions.GetPdfItemAction({ id: id }));
    }
    doClearGetPdfItemState(): void {
        this.appState$.dispatch(new actions.ClearGetPdfItemStateAction({}));
    }

    doGetPdfList(params: any): void {
        this.appState$.dispatch(new actions.GetPdfListAction(params));
    }
    doClearGetPdfListState(): void {
        this.appState$.dispatch(new actions.ClearGetPdfListStateAction({}));
    }

    doRemovePdfItem(id: number): void {
        this.appState$.dispatch(new actions.DeletePdfItemAction({ id: id }));
    }
    doClearRemovePdfItemState(): void {
        this.appState$.dispatch(new actions.ClearDeletePdfItemStateAction({}));
    }

    doUpdatePdfItem(id: number, params: any): void {
        this.appState$.dispatch(new actions.UpdatePdfItemAction({ id: id, params: params }));
    }
    doClearUpdatePdfItemState(): void {
        this.appState$.dispatch(new actions.ClearUpdatePdfItemStateAction({}));
    }

    // 

    doCreateSlider(params: any): void {
        this.appState$.dispatch(new actions.CreateSliderAction(params));
    }
    doClearCreateSliderState(): void {
        this.appState$.dispatch(new actions.ClearCreateSliderStateAction({}));
    }

    doGetSlider(id: number): void {
        this.appState$.dispatch(new actions.GetSliderAction({ id: id }));
    }
    doClearGetSliderState(): void {
        this.appState$.dispatch(new actions.ClearGetSliderStateAction({}));
    }

    doGetSliders(params: any): void {
        this.appState$.dispatch(new actions.GetSlidersAction(params));
    }
    doClearGetSlidersState(): void {
        this.appState$.dispatch(new actions.ClearGetSlidersStateAction({}));
    }

    doRemoveSlider(id: number): void {
        this.appState$.dispatch(new actions.RemoveSliderAction({ id: id }));
    }
    doClearRemoveSliderState(): void {
        this.appState$.dispatch(new actions.ClearRemoveSliderStateAction({}));
    }

    doUpdateSlider(id: number, params: any): void {
        this.appState$.dispatch(new actions.UpdateSliderAction({ id: id, params: params }));
    }
    doClearUpdateSliderState(): void {
        this.appState$.dispatch(new actions.ClearUpdateSliderStateAction({}));
    }

}
